import { useEffect, useState } from 'react';
import { List, ListItem, Typography, Button, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';


import Modal from '@mui/material/Modal';
import { useData } from '../hooks/DataProvider';
import translations from '../scripts/translations';

import { getBillingItems } from '../api/billingItems';
import { getTypeOfGoods } from '../api/typeOfGoods';

import { EuropeanCountryCodes } from '../scripts/configData';


import { taxationAutoForCurrentSelectedService } from '../scripts/automaticTaxation';



const SearchBlock = ({ options, handleClientSelect, handleClear }) => {

    const { language } = useData();

    return (
        <Box sx={{ height: '90vh', overflowY: 'auto', padding: '8px' }}>

            <List >
                {options.map((option) => (
                    <ListItem
                        key={option._id}
                        onClick={() => handleClientSelect({option})}
                        disablePadding
                        sx={{
                            cursor: 'pointer',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '8px',
                            mb: '4px',
                            display: 'flex',
                            gap: 3,
                            maxHeight: '100px',
                            overflow: 'hidden',
                        }} >
                        <Typography variant="subtitle1" >{option.code}</Typography>
                        {
                            language === 'fr' ?
                                <Typography variant="subtitle1" >{option.designationFr}</Typography>
                                :
                                <Typography variant="subtitle1" >{option.designationEn}</Typography>
                        }

                    </ListItem>
                ))}
            </List>
        </Box>
    );
}


const BillingItemsSearchBox = ({ data, updateData }) => {

    const { language, dataShipement } = useData();
    const button = translations.button[language];

    const [items, setItems] = useState([]);
    const [priceForTypeOfGoods, setPriceForTypeOfGoods] = useState(0);

    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(true);
        if (items.length === 0) {
            console.log('Opening modal, fetching items...');
            getBillingItems({}).then(data => {
                if (data) {
                    data.sort((a, b) => a.code.localeCompare(b.code));
                    setItems(data);
                    console.log('Billing items fetched:', data);
                }
            });
        }
    };
    const handleClose = () => setOpen(false);

    const style = {
        position: 'absolute',
        top: '20%',
        left: '20%',
        transform: 'translate(-20%, -20%)',
        width: '80%',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius: '8px',
        // height: '80vh',
        minHeight: '300px',
    };

    const handleClientSelect = ({option}) => {

        const newData = taxationAutoForCurrentSelectedService({
            dataShipement, data, priceForTypeOfGoods, option
        });


        updateData({ ...newData, itemCode: option.code, designation: { fr: option.designationFr, en: option.designationEn }, bI: option });
        setItems([])
        handleClose();
    }



    const handleClear = () => {
        updateData({ ...data, itemCode: '', designation: { fr: '', en: '' } });
        setItems([]);
        handleClose();
    }


    useEffect(() => {

        console.log('Fetching prices for type of goods:', dataShipement.goodsDescription);

        getTypeOfGoods({ code: dataShipement.goodsDescription }).then(data => {
            if (data) {
                let p = data.filter(item => item.key === dataShipement.goodsDescription)
                if (p.length === 0) {
                    p = 0
                }
                else {
                    p = p[0].unitPrice
                }
                setPriceForTypeOfGoods(p);
                console.log('Prices for type of goods fetched:', p);
            }
        });

    }, [dataShipement.goodsDescription]);



    return (
        <Box>

            <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <Button
                    size='small'
                    onClick={handleOpen}
                    variant='outlined'
                    style={{ textTransform: "none", minWidth: "30px" }} >
                    <SearchIcon />
                </Button>
                <Button
                    size='small'
                    onClick={handleClear}
                    variant='outlined'
                    style={{ textTransform: "none", minWidth: "30px" }} >
                    <ClearIcon />
                </Button>
            </Box>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <SearchBlock
                        options={items}
                        handleClientSelect={handleClientSelect}
                        handleClear={handleClear}
                    />
                    <Button variant="outlined" onClick={handleClose} sx={{ mt: 2 }}>{button.close}</Button>
                </Box>
            </Modal>

        </Box>
    );
}

export { BillingItemsSearchBox };
